import { getCurrentDatetime } from './dateFormat'

type TPlaceHolderValues = {
	current_month: string
	current_date: string
}

function replacePlaceHolder(template: string, values: TPlaceHolderValues) {
	return template.replace(/{(\w+)}/g, (_, key) => values[key] || '')
}

/**
 * Convert meta data title
 * @param {string} text The text processed
 * @returns {string} Processed string
 */
export function convertMetaInfo(text?: string): string {
	if (!text) {
		return ''
	}
	const placeHolderValues: TPlaceHolderValues = {
		current_date: getCurrentDatetime(),
		current_month: 'tháng ' + (new Date().getMonth() + 1)
	}
	return replacePlaceHolder(text, placeHolderValues)
}
